var _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgStatsLeaf(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#21D0BE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5516 11.2924C12.9294 10.5493 13.1728 9.34183 12.8496 7.99949C12.6807 7.33706 12.3659 6.63551 11.8383 6.0411C11.3175 5.44477 10.63 4.94233 9.83877 4.58883C9.05741 4.21526 8.15207 4.0858 7.22977 4.01258C6.30406 3.96905 5.35706 4.0401 4.42582 4.20054C3.9601 4.28033 3.49823 4.38486 3.04586 4.5119L3 4.52566C3.0806 4.56746 3.1618 4.60744 3.23709 4.66152C4.14773 5.18091 4.63348 6.17504 4.9427 7.01687C5.26175 7.87868 5.57073 8.67551 6.00093 9.36069C6.41994 10.032 6.9275 10.652 7.45756 11.0594C8.56389 11.8639 9.71872 12.2357 10.5454 12.3338C10.9942 12.3991 11.3315 12.4171 11.5564 12.4211C11.5264 12.2676 11.3004 9.7549 9.64961 7.96513C8.40587 6.61637 6.81347 5.46623 6.81347 5.46623C6.81347 5.46623 8.28387 5.85245 10.0572 7.6364C11.7887 9.3782 12.0109 12.0509 12.035 12.165C12.0444 12.1513 12.048 12.146 12.0584 12.1313C12.1969 11.9513 12.377 11.6735 12.5517 11.2924L12.5516 11.2924Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatsLeaf);
export default __webpack_public_path__ + "static/media/stats-leaf.847e3f4f.svg";
export { ForwardRef as ReactComponent };